import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from "@/views/Login.vue";
import Top from "@/views/Top.vue";
import Ticket from "@/views/Ticket.vue";
import Subscription from "@/views/Subscription.vue";
import SubscriptionStop from "@/views/SubscriptionStop.vue";
import Profile from "@/views/Profile.vue";
import UseHistory from "@/views/UseHistory.vue";
import PointHistory from "@/views/PointHistory.vue";
import LostPassword from "@/views/LostPassword.vue";

/*
import Contract from "@/views/Contract.vue";
*/
Vue.use(VueRouter)

const routes = [
/*
  {
    path: "/checkin",
    name: "UfCheckIn",
    component: UfCheckIn,
    props: (route) => ({ eid: route.query.eid, ueid: route.query.ueid })
  },*/
  {
    path: "/subscription",
    name: "Subscription",
    component: Subscription,
  },
  {
    path: "/subscription_stp",
    name: "SubscriptionStop",
    component: SubscriptionStop,
  },
  {
    path: "/ticket",
    name: "Ticket",
    component: Ticket,
  },
  {
    path: "/top",
    name: "Top",
    component: Top,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/usehistory",
    name: "UseHistory",
    component: UseHistory,
  },
  {
    path: "/pointhistory",
    name: "PointHistory",
    component: PointHistory,
  },
  {
    path: "/lostpassword",
    name: "LostPassword",
    component: LostPassword,
  },

  
  { path: '*', redirect: '/top' }
]

const router = new VueRouter({
  //mode: "history",
  routes
})

export default router
